var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_7361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1923 31.1756C24.0226 31.1756 31.0402 20.5458 31.0402 11.3278C31.0402 11.0258 31.0402 10.7253 31.0198 10.4261C32.385 9.4386 33.5634 8.21591 34.5 6.81528C33.227 7.37968 31.8764 7.74965 30.4934 7.9128C31.9497 7.04111 33.0396 5.66991 33.5602 4.05448C32.191 4.86709 30.6929 5.43973 29.1307 5.74768C28.079 4.62933 26.688 3.88879 25.1729 3.64065C23.6579 3.39251 22.1033 3.65061 20.7498 4.375C19.3962 5.0994 18.3191 6.24971 17.6852 7.64792C17.0513 9.04613 16.8959 10.6143 17.243 12.1098C14.4696 11.9706 11.7565 11.2499 9.27973 9.99428C6.80297 8.73868 4.61792 6.9763 2.8664 4.82152C1.97437 6.35718 1.70115 8.17509 2.10239 9.90511C2.50363 11.6351 3.54915 13.1472 5.02608 14.1334C3.91591 14.1009 2.82992 13.8014 1.86 13.2603V13.3487C1.86044 14.9593 2.41796 16.5201 3.43798 17.7664C4.45801 19.0127 5.87775 19.8679 7.4564 20.1868C6.42943 20.4669 5.35191 20.5079 4.30664 20.3065C4.75257 21.6924 5.62044 22.9044 6.78892 23.773C7.9574 24.6415 9.36809 25.1233 10.8238 25.1508C9.37745 26.2876 7.7212 27.1282 5.94974 27.6243C4.17828 28.1204 2.32639 28.2624 0.5 28.0422C3.6901 30.0893 7.40189 31.1751 11.1923 31.1702",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_7361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.5 0.71582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSocialIcon);
export default __webpack_public_path__ + "static/media/twitter-social-icon.acc7ddaa98c0adc22fdaf57f04f710cf.svg";
export { ForwardRef as ReactComponent };